module.exports = __webpack_public_path__ + "GoldCoastNannies_Logo_FullColor-01.png?f6e03e9fae27d085e844dc9bedf6c967";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/GoldCoastNannies_Logo_FullColor-01.png
// module id = 596
// module chunks = 0